import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import calendar from 'dayjs/plugin/calendar';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppStateProvider } from './hooks/useAppState';
import { ConfigProvider } from './hooks/useConfig';
import './index.css';
import './styles/globals.css';
import App from './pages/App/App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(calendar);
dayjs.extend(localizedFormat);

const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
dayjs.tz.setDefault(tz);

const config = {
  // proxyUrl: 'https://graphql.coreapi.gcpuatau.tbm.sh/query',
};

root.render(
  <React.StrictMode>
    <ConfigProvider config={{ ...config }}>
      <AppStateProvider>
        <App />
      </AppStateProvider>
    </ConfigProvider>
  </React.StrictMode>
);
